import { ChevronDownGray400 } from '@assets/icons';
import { Select as MuiSelect, SelectChangeEvent, SelectProps } from '@mui/material';
import React, { CSSProperties } from 'react';
import { Text } from '../common/Text';
import { colorSet } from '@theme';

type ISelectProps = SelectProps & {
  label?: string;
  boxstyle?: CSSProperties;
  placeholder?: string;
  disabled?: boolean;
  multiple?: boolean;
  onChange?: (event: SelectChangeEvent<any>, child?: React.ReactNode) => void;
};

export const Select: React.FC<React.PropsWithChildren<ISelectProps>> = (props) => {
  const { label, boxstyle, placeholder, disabled = false, multiple = false, onChange, children, ...rest } = props;

  return (
    <div style={boxstyle}>
      {label ? (
        <Text variant="subtitle" fontWeight="bold" marginBottom="8px">
          {label}
        </Text>
      ) : null}

      <MuiSelect
        fullWidth
        displayEmpty
        variant="outlined"
        disabled={disabled}
        multiple={multiple}
        onChange={(event, child) => {
          if (onChange) {
            onChange(event, child);
          }
        }}
        IconComponent={(props) => (
          <ChevronDownGray400
            style={{
              width: 20,
              height: 20,
              position: 'absolute',
              right: '16px',
              pointerEvents: 'none'
            }}
          />
        )}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 386,
              '&::-webkit-scrollbar': {
                width: '8px',
                height: '0px'
              },
              '&::-webkit-scrollbar-thumb': {
                borderRadius: '8px',
                backgroundColor: colorSet.primaryMain
              },
              '&::-webkit-scrollbar-track': {
                borderRadius: '8px',
                backgroundColor: colorSet.gray200
              }
            }
          },
          classes: {
            paper: 'scroll'
          }
        }}
        {...rest}
      >
        {children}
      </MuiSelect>
    </div>
  );
};
